<template>
  <div>
    <h4>데이터 업로드</h4>
    <p></p>
    <b-card>
      <b-card-title>데이터 업로드 방법</b-card-title>
<!-- 
      조직의 제품과 시설을 등록하면, 공급망 데이터를 KFT Food TrustT™에 업로드할 준비가 된 것입니다.
      <br>다음 데이터 업로드 방법 중 하나 이상을 선택할 수 있습니다:
      <h6>
        1. 스프레드시트,
        2. 제품 시나리오 XML 또는
        3. 자동화된 XML. </h6>
      <p></p>
      
      이러한 방법은 복잡성과 기능이 다양하므로 환경과 온보딩 팀에 가장 적합한 선택을 해야 합니다. -->

      <b-card-body>
        조직의 제품과 시설을 등록하면, 공급망 데이터를 KFT Food TrustT™에 업로드할 준비가 된 것입니다.
      <p>다음 데이터 업로드 방법 중 하나 이상을 선택할 수 있습니다</p>
      <h6>
        1. 스프레드시트,
        2. 제품 시나리오 XML 또는
        3. 자동화된 XML. </h6>
      <p class="mb-0"></p>
      
      
      <p>이러한 방법은 복잡성과 기능이 다양하므로 환경과 온보딩 팀에 가장 적합한 선택을 해야 합니다.</p>
        <ul class="list-group">
          <li class="list-group-item list-group-item-secondary"><h5>1. Spreadsheets</h5>제공된 Microsoft® Excel™ <b-link href="#/template/spreadsheet"><b> 스프레드시트 템플릿</b></b-link>을 사용하여 데이터를 기록하고 KFT Food Trust에 업로드하십시오. 이 방법은 UI 온보딩 모듈에서 제품, 시설, 이벤트 및 트랜잭션 데이터를 업로드하는 것을 지원합니다.
          Onboarding module.</li>
          <li class="list-group-item list-group-item-secondary"> <h5>2. Product scenarios XML</h5><b-link href="#/scenario/build"><b>  제품 시나리오 빌더</b></b-link>를 사용하여 일반적인 공급망 데이터 흐름을 매핑하십시오. 그런 다음 각 시나리오를 데이터를 캡처하고 업로드를 자동화하기 위한 XML 템플릿으로 저장합니다.</li>
          <li class="list-group-item list-group-item-secondary"><h5>3. Automated XML </h5> 자동화된 데이터 업로드 프로세스를 따라 KFT Food Trust에 호환 데이터를 캡처하고 업로드하기 위한 로컬 시스템을 구성하십시오. 이 프로세스는 이미 데이터를 매핑하고 XML 템플릿을 저장해야 합니다.</li>
        </ul>
      </b-card-body>
    </b-card>
    <p></p>
  </div>

</template>
<script>

// import OrganizationDetailsVue from './OrganizationDetails.vue';

export default {
  components: {
    // OrganizationDetailsVue
  },
  created() {
    this.$_loadingTimeInterval = null
  },
  mounted() {
    this.startLoading();
    // this.search()
  },
  async beforeMount() {
    this.company = await this.$getOrganization();
    this.onComplate = true
  },
  data() {
    return {
      onComplate: false,
      loading: false,
      perPage: 5,
      currentPage: 1,
      showDetail: false,
      updateMode: false,
      checked: false,
      facility: {
        facilityId: null,
        facilityName: null,
        facilityType: null,
        facilityIdType: 'KFT',//GS1 OR KFT
        streetAddress: null,
        city: null,
        state: null,
        postalCode: null,
        country: null,
        gpsX: null,//for wgs84
        gpsY: null,//for wgs84
      },
      company: null,
      items: [],
      fields: [
        { key: 'no', label: 'No.', class: 'text-center' },
        { key: 'organizationPrefix', label: 'Organization Prefix', class: 'text-center' },
        { key: 'prefixType', label: 'Prefix Type', class: 'text-center' }
      ],
    }
  },
  methods: {
    onRefresh() {
      // console.log('OnRefresh')
      this.startLoading();
      // this.search();
    },
    async search(ctx) {
      const org = await this.$getOrganization();
      try {
        const response = await this.$http.get(`${org._links.facilities.href}${this.pagination()}`);
        console.log(response)
        this.items = response.data._embedded.facility;
      } catch (err) {
        alert(err)
        // alert('조회 중 에러가 발생하였습니다.');
      }
      return this.items;
    },

    pagination(ctx) {
      if (ctx) {
        return `?page=${ctx.currentPage - 1}&size=${ctx.perPage}`;
      }
      return ''
    },
    myRowClickHandler(record) {
      this.register();
      this.facility = Object.assign({}, record);
      this.updateMode = true;
    },
    register(event) {
      this.showDetail = true;
      this.updateMode = false
      this.$nextTick(() => {
        //do nothing
      })
    },

    clearLoadingTimeInterval() {
      clearInterval(this.$_loadingTimeInterval)
      this.$_loadingTimeInterval = null
    },

    startLoading() {
      this.loading = true
    },
    onClosed() {
      this.showDetail = false;
    },

    fmtSddress(value, key, facility) {
      const address = [];
      if (facility.streetAddress) address.push(facility.streetAddress + '<br>');
      if (facility.city) address.push(facility.city);
      if (facility.state) address.push(facility.state);
      if (facility.country) address.push(facility.regionName);
      return address.join(' ');
    },
    download(file) {
      console.log(file)

      window.href = file
    }
  },
  computed: {
    rows() {
      // console.log(this.items.length)
      return this.items.length
    }
  },
  watch: {
    loading(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.clearLoadingTimeInterval()
        if (newValue) {
          this.$_loadingTimeInterval = setInterval(() => {
            this.loading = false;
            this.onComplate = true;
          }, 1000)
        }
      }
    },
  }
}
</script>
<style scoped>
/* .card-body>>>table>tbody>tr>td {
  cursor: pointer;
} */
</style>
